import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { EmailLandingService } from '../../../Core/Services';

@Injectable({
  providedIn: 'root'
})
export class QuoteEmailLandingService {
  constructor(private landingService: EmailLandingService) { }

  processLanding(): Observable<any> {
    return this.landingService.getLandingResponse();
  }

  getGeneratedSignature() {
    return this.landingService.generateClientSignature();
  }
}
